import {handleActions} from 'redux-actions';
import actions from './reviews.actions';

const reducer = handleActions(
	{
		[actions.reviewsLoaded]: (state, {payload}) => ({
			...state,
			items: [...payload]
		}),
		[actions.reviewsNewOpen]: state => ({
			...state,
			editing: {
				rating: null,
				communication: null,
				quality: null,
				affordability: null,
				trust: null,
				content: ''
			}
		}),
		[actions.reviewsNewSaved]: (state, {payload}) => ({
			...state,
			items: state.items
				.filter(review => review.reviewer.uuid !== payload.uuid)
				.concat({
					...state.editing,
					reviewer: payload
				}),
			editing: null,
			editingReview: false
		}),
		[actions.reviewsNewCancelled]: state => ({
			...state,
			editing: null
		}),
		[actions.reviewsNewUpdate]: (state, {payload}) => ({
			...state,
			editing: {
				...state.editing,
				...payload
			}
		}),
		[actions.reviewsEditOpen]: (state, {payload}) => ({
			...state,
			editingReview: true,
			editing: {
				...payload
			}
		})
	},
	{
		items: null,
		editing: null
	}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/profile/reviews.reducer.js